export const incomeTypes = {
  employment_w2: {
    title: "Employment - W2",
    description:
      "Income from employment where the employee receives a W2 form.",
  },
  food_stamps_snap: {
    title: "Food Stamps (SNAP)",
    description: "Supplemental Nutrition Assistance Program benefits.",
  },
  bonuses_and_commissions: {
    title: "Bonuses and Commissions",
    description: "Additional income from bonuses or commissions earned.",
  },
  self_employment_1099: {
    title: "Self-Employment - 1099",
    description: "Income from self-employment reported on a 1099.",
  },
  disability_benefits: {
    title: "Disability Benefits",
    description: "Income from disability assistance or insurance.",
  },
  public_assistance: {
    title: "Public Assistance",
    description: "Government assistance payments for general support.",
  },
  supplemental_social_security: {
    title: "Supplemental Social Security",
    description: "Supplemental Security Income (SSI) benefits.",
  },
  unemployment_benefits: {
    title: "Unemployment Benefits",
    description: "Payments received while unemployed.",
  },
  workers_compensation: {
    title: "Workers' Compensation",
    description: "Compensation benefits from a work-related injury or illness.",
  },
  pension: {
    title: "Pension",
    description: "Regular income from a pension plan.",
  },
  retirement_income: {
    title: "Retirement Income",
    description: "Income from retirement accounts or annuities.",
  },
  child_support: {
    title: "Child Support",
    description: "Payments received as child support.",
  },
  fellowships_stipends: {
    title: "Fellowships & Stipends",
    description: "Academic fellowships or stipends.",
  },
  tax_refund: {
    title: "Tax Refund",
    description: "Refund received from overpaid taxes.",
  },
  rental_income: {
    title: "Rental Income",
    description: "Income from renting property.",
  },
  interest_dividends: {
    title: "Interest & Dividends",
    description: "Income from interest or dividend payments.",
  },
  loan_asset: {
    title: "Loan Asset",
    description: "Income from loans or repayments.",
  },
  other_asset: {
    title: "Other Asset",
    description: "Income from miscellaneous assets.",
  },
  other_income: {
    title: "Other Income",
    description: "Other types of income not otherwise categorized.",
  },
  annuity_payments: {
    title: "Annuity Payments",
    description: "Regular income from annuity contracts.",
  },
  business_interest_or_business_related: {
    title: "Business Interest or Business Related",
    description: "Income from business investments or ownership.",
  },
  social_security_retirement: {
    title: "Social Security Retirement",
    description: "Social Security retirement benefits.",
  },
  veterans_benefits: {
    title: "Veterans Benefits",
    description: "Payments received as veterans' benefits.",
  },
  spousal_support: {
    title: "Spousal Support",
    description: "Payments received as spousal support (alimony).",
  },
};

export type IncomeType = keyof typeof incomeTypes;
